<template>
  <li>
    <RouterLink
        class="dropdown-item"
        :to=" linkName ">
      <span class="">
            <i :class="['fa-solid me-1', icon]"></i>
            {{ title }}
      </span>
    </RouterLink>
  </li>
</template>

<script>
export default {
  name: "Li",
  data() {
    return {
    }
  },
  props: {
    title: {
      type: String,
      default: "List Item Name"
    },
    linkName:{
      type: String,
      require: true,
    },
    icon:{
      type: String,
      default: "fa-user"
    }
  },
}
</script>

<style scoped>

</style>